import { GameState } from "../state";
import { dist, len } from "../../core/math";
import { pickupRadius } from "../stats";

// Pickups drift, then home toward PCKT once inside the magnet radius, then are
// collected into bandwidth (XP) or fragments (currency).
export function updatePickups(s: GameState, dt: number): void {
  const p = s.player;
  const magnetR = pickupRadius(s.stats);
  const collectR = p.radius + 10;

  for (const pk of s.pickups) {
    if (!pk.alive) continue;

    // Initial scatter friction.
    pk.vx *= 0.9;
    pk.vy *= 0.9;

    const d = dist(pk.x, pk.y, p.x, p.y);

    // Lifespan: XP orbs left on the board despawn. Always counts down (so an orb
    // a fast player outruns can't live forever), but homing refreshes a grace
    // below so it never vanishes during a normal flight to PCKT.
    if (pk.life !== undefined) {
      pk.life -= dt;
      if (pk.life <= 0) {
        pk.alive = false;
        continue;
      }
    }

    if (pk.magnet || d < magnetR) {
      if (!pk.magnet && pk.life !== undefined) pk.life = Math.max(pk.life, 3.5);
      pk.magnet = true;
      const dx = p.x - pk.x;
      const dy = p.y - pk.y;
      const m = len(dx, dy) || 1;
      const pull = 520;
      pk.vx = (dx / m) * pull;
      pk.vy = (dy / m) * pull;
    }

    pk.x += pk.vx * dt;
    pk.y += pk.vy * dt;

    if (d < collectR) {
      pk.alive = false;
      if (pk.kind === "bandwidth") {
        s.addBandwidth(pk.value);
      } else {
        s.addFragments(pk.value);
        s.addFloat(p.x, p.y - p.radius - 10, "+" + pk.value, "#c6c684", 14);
      }
    }
  }

  if (s.pickups.length > 800) s.pickups = s.pickups.filter((pk) => pk.alive);
}
